import { useMemo } from 'react';

import { StyledErrorTitle } from './ErrorSummaryAtom.styled';

/* ---------------------------------- Types --------------------------------- */

export interface DumbErrorSummaryAtomI {
    /** An object containing errors to display */
    errors: Record<string, string | undefined>;

    /** Dictionary of translations */
    dictionary: Record<string, string>;
}

/* -------------------------------- Component ------------------------------- */

const DumbErrorSummaryAtom = ({
    errors,
    dictionary,
}: DumbErrorSummaryAtomI) => {
    const errorArray = Object.values(errors).filter(Boolean);

    const summary = useMemo(
        () => dictionary['common.error.field'],
        [dictionary],
    );

    // Display arbitrary error message if exists
    if (errors['*']) {
        const maybeDictionaryKey = errors['*'];
        const displayError =
            dictionary[maybeDictionaryKey] ?? maybeDictionaryKey;
        return <StyledErrorTitle>{displayError}</StyledErrorTitle>;
    }

    return errorArray.length < 1 ? null : (
        <StyledErrorTitle>{summary}</StyledErrorTitle>
    );
};

/* --------------------------------- Export --------------------------------- */

export default DumbErrorSummaryAtom;
